import React from "react";
import { Construction } from "lucide-react";
import { PageHeader } from "../components/core/Layout";

export default function ComingSoonPage({ title, eyebrow, description }: { title: string; eyebrow?: string; description?: string }) {
  return (
    <div data-testid="coming-soon-page">
      <PageHeader eyebrow={eyebrow || "Module"} title={title} subtitle={description || "This section is scaffolded and will be activated in an upcoming phase."} />
      <div className="card-crisp flex flex-col items-center justify-center px-6 py-16 text-center opacity-80 grayscale">
        <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-slate-100 text-slate-500"><Construction className="h-6 w-6" /></span>
        <h2 className="mt-4 font-display text-base font-semibold text-slate-700 md:text-lg">{title} — not available yet</h2>
        <p className="mt-1 max-w-md text-sm text-slate-500">This is a placeholder: no real data is shown here. The section is reserved in the navigation and will be switched on in a later phase — nothing is required from you until then.</p>
      </div>
    </div>
  );
}
